import { render, staticRenderFns } from "./UserAuditLog.vue?vue&type=template&id=5f59e546&scoped=true&"
import script from "./UserAuditLog.vue?vue&type=script&lang=js&"
export * from "./UserAuditLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f59e546",
  null
  
)

export default component.exports